import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllMachineFeatureMapping } from "../actions/machine-action-types";
import { isEmpty } from "lodash";

const useGetMachineFeatureMapping = () => {
  const dispatch = useDispatch();

  const allModelsMapping = useSelector(
    (state) => state?.machine?.allMachineFeatureMapping
  );

  const modelsList = useMemo(() => {
    let result = [];
    if (!isEmpty(allModelsMapping)) {
      for (let item of allModelsMapping) {
        const addedItem =
          result.find((obj) => {
            return obj.modelName === item.modelName;
          }) ?? {};
        if (isEmpty(addedItem)) {
          const modelObj = {
            modelName: item.modelName,
            modelDesc: item.modelDesc,
            productImage: item.modelImgUrl,
            detailUrl: item.equipmentUrl,
            enginePower: [item.hp],
            price: item.price,
            operatorManualPdfUrl: item.operatorManualPdfUrl ?? "",
            equipmentUrl: item.equipmentUrl,
            productName: item.productName ?? "",
            variants: [
              {
                variantId: item.variantId,
                variantName: item.variantName,
                productImage: item.variantGrpImgUrl ?? item.modelImgUrl,
                enginePower: item.hp,
                price: item.price,
                features: [
                  {
                    featureId: item.featureId,
                    grpFeatureId: item.grpFeatureId,
                    groupId: item.groupId,
                    groupName: item.groupName,
                    featureName: item.featureName?.trim(),
                    value: item.detail,
                    grpFeatureDtlId: item.grpFeatureDtlId,
                    grpFeatureVariantId: item.grpFeatureVariantId,
                    isModelDtlEnabled: item.isModelDtlEnabled,
                  },
                ],
              },
            ],
          };
          result.push(modelObj);
        } else {
          // Check Variants
          const variants = addedItem.variants;
          const addedVariant = variants.find((obj) => {
            return obj.variantId === item.variantId;
          });
          if (isEmpty(addedVariant)) {
            const updatedVariants = [
              ...variants,
              {
                variantId: item.variantId,
                variantName: item.variantName,
                productImage: item.variantGrpImgUrl ?? item.modelImgUrl,
                enginePower: item.hp,
                price: item.price,
                features: [
                  {
                    featureId: item.featureId,
                    grpFeatureId: item.grpFeatureId,
                    groupId: item.groupId,
                    groupName: item.groupName,
                    featureName: item.featureName?.trim(),
                    value: item.detail,
                    grpFeatureDtlId: item.grpFeatureDtlId,
                    grpFeatureVariantId: item.grpFeatureVariantId,
                    isModelDtlEnabled: item.isModelDtlEnabled,
                  },
                ],
              },
            ];
            // check HP also
            const isHPAdded = addedItem.enginePower?.includes(item.hp);
            result = result.map((rItem) => {
              if (rItem.modelName === addedItem.modelName) {
                return {
                  ...rItem,
                  enginePower: !isHPAdded
                    ? [...rItem.enginePower, item.hp]
                    : rItem.enginePower,
                  variants: updatedVariants,
                };
              }
              return rItem;
            });
          } else {
            // Check Features
            const features = addedVariant.features;
            const addedFeature = features.find((obj) => {
              return obj.featureId === item.featureId;
            });
            if (isEmpty(addedFeature)) {
              const updatedFeatures = [
                ...features,
                {
                  featureId: item.featureId,
                  grpFeatureId: item.grpFeatureId,
                  groupId: item.groupId,
                  groupName: item.groupName,
                  featureName: item.featureName?.trim(),
                  value: item.detail,
                  grpFeatureDtlId: item.grpFeatureDtlId,
                  grpFeatureVariantId: item.grpFeatureVariantId,
                  isModelDtlEnabled: item.isModelDtlEnabled,
                },
              ];
              const updatedVariants = variants.map((rItem) => {
                if (rItem.variantId === addedVariant.variantId) {
                  return { ...rItem, features: updatedFeatures };
                }
                return rItem;
              });
              // check HP also
              const isHPAdded = addedItem.enginePower?.includes(item.hp);
              result = result.map((rItem) => {
                if (rItem.modelName === addedItem.modelName) {
                  return {
                    ...rItem,
                    enginePower: !isHPAdded
                      ? [...rItem.enginePower, item.hp]
                      : rItem.enginePower,
                    variants: updatedVariants,
                  };
                }
                return rItem;
              });
            }
          }
        }
      }
      console.log("result, current", result);
      return result;
    }
    return result;
  }, [allModelsMapping]);

  const getModelDetails = useCallback(
    (modelName) => {
      const modelItem = modelsList.find((obj) => {
        return obj.modelName === modelName;
      });
      return modelItem ?? {};
    },
    [modelsList]
  );

  // Fetch All Machine Feature Mapping List
  const fetchMachineFeatureMapping = () => {
    dispatch(getAllMachineFeatureMapping());
  };

  return { fetchMachineFeatureMapping, modelsList, getModelDetails };
};

export default useGetMachineFeatureMapping;
